<template>
  <b-card class="mb-3">
    <div class="d-flex justify-content-between mb-3" v-if="title">
      <h2 class="mb-0">Recent Reviews</h2>

      <b-btn variant="secondary" size="sm" to="/admin/reviews">
        View More
      </b-btn>
    </div>
    <div class="d-flex justify-content-end mx-2 mb-3">
      <b-btn variant="secondary" size="sm" @click="exportReviews()">
        Export
      </b-btn>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Reviewer</th>
          <th>Subject</th>
          <th>Meeting</th>
          <th>Review</th>
          <th>Notes</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="results.length === 0">
          <td class="text-center" colspan="6">
            <em>No reviews found!</em>
          </td>
        </tr>

        <tr v-for="review in results" :key="review.uuid">
          <td>
            <router-link :to="`/user/${review.user.uuid}`">
              <img
                class="rounded-circle img-profile mr-2"
                :src="review.user.avatar"
                :alt="`${review.user.first_name} ${review.user.last_name}`"
              >
              {{ review.user.first_name }} {{ review.user.last_name }}
            </router-link>
          </td>
          <td>
            <router-link
              v-if="review.user.uuid !== review.meeting.invitee.uuid"
              :to="`/user/${review.meeting.invitee.uuid}`"
            >
              <img
                class="rounded-circle img-profile mr-2"
                :src="review.meeting.invitee.avatar"
                :alt="`${review.meeting.invitee.first_name} ${review.meeting.invitee.last_name}`"
              >
              {{ review.meeting.invitee.first_name }} {{ review.meeting.invitee.last_name }}
            </router-link>

            <router-link
              v-if="review.user.uuid !== review.meeting.inviter.uuid"
              :to="`/user/${review.meeting.inviter.uuid}`"
            >
              <img
                class="rounded-circle img-profile mr-2"
                :src="review.meeting.inviter.avatar"
                :alt="`${review.meeting.inviter.first_name} ${review.meeting.inviter.last_name}`"
              >
              {{ review.meeting.inviter.first_name }} {{ review.meeting.inviter.last_name }}
            </router-link>
          </td>
          <td>
            <small>
              {{ review.meeting.date }}<br>
              {{ review.meeting.start_time }} to {{ review.meeting.end_time }}
            </small>
          </td>
          <td>
            <star-rating
              :show-rating="false" :increment="0.5" :star-size="14" read-only
              v-model="review.rating"
            />
          </td>
          <td><small>{{ review.notes }}</small></td>
          <td>
            <b-btn
              variant="danger" size="sm" block
              @click="deleteModel(review)"
            >
              Delete
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center" v-if="pagination">
      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page - 1)" :disabled="loading || page === 1"
      >
        Prev Page
      </b-btn>

      <span class="text-muted" v-if="!loading">
        Page {{ page }} of {{ totalPages }}
      </span>

      <span class="text-muted" v-if="loading">
        Loading
      </span>

      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page + 1)" :disabled="loading || page === totalPages"
      >
        Next Page
      </b-btn>
    </div>
  </b-card>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'ReviewsTable',
  props: {
    count: Number,
    pagination: Boolean,
    title: Boolean
  },
  components: {
    StarRating
  },
  data () {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      results: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true

      this.$http.get('/admin/reviews?page=' + this.page + '&page_count=' + this.count)
        .then(res => {
          this.results = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },
    setPage (page) {
      this.page = page
      this.load()
      window.scrollTo(0,0)
    },
    deleteModel (review) {
      if (!window.confirm('Are you sure you want to delete this review?')) {
        return
      }

      this.loading = true

      this.$http.delete(`/admin/reviews/${review.uuid}`)
        .then(() => {
          this.load()
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportReviews() {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$http.post(`/admin/reviews/export`)
        .then(res => {
            var fileUrl = window.URL.createObjectURL(new Blob([res.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileUrl
            fileLink.setAttribute('download', 'reviews.csv')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
